// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import format from 'date-fns/format';
import { useNavigate } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import Heading from '../../../../../generic-components/Heading';
import { useStore } from '../../../../../store';
import {
  BUTTONS_TITLES, INITIAL_BILL_DATA_MODEL, STYLES, TEXTS,
} from '../consts';
import Button from '../../../../../generic-components/Button';
import { ReactComponent as AttachmentAdded } from '../../../../../assets/icons/svg/colored-icons/ic-colored-attachment.svg';
import { Avatar, AvatarSize } from '../../../../../DesignSystem/VendorProfile/Avatar';
import { convertValueToUSD } from '../../../../../helpers/currency.helper';
import { VIEWS_MAP } from '../../../../../router/constants';

export const BillCreationSuccess = () => {
  const { t } = useTranslation();
  const billData = useStore(state => state.billData);
  const routerHistory = useStore(state => state.routerHistory);
  const setBillData = useStore(state => state.setBillData);
  const setSelectedVendorId = useStore(state => state.setSelectedVendorId);
  const selectedVendor = useStore(state => state.getSelectedVendor());
  const navigate = useNavigate();

  const handleProceedToPayment = () => {
    navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.PAY_BILL.BASE}/${billData.billId}`, { state: { billId: billData.billId }, replace: true });
  };

  const handleMakeAnotherBill = () => {
    mixpanel.track('Act on bill creation success screen', { Action: 'add another bill' });
    setBillData(INITIAL_BILL_DATA_MODEL);
    setSelectedVendorId('');
    navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.ADD_NEW_BILL}`);
  };

  const handleDone = () => {
    mixpanel.track('Act on bill creation success screen', { Action: 'done' });
    setBillData(INITIAL_BILL_DATA_MODEL);
    setSelectedVendorId('');
    navigate(`/${VIEWS_MAP.BILLS.BASE}`, { replace: true });
  };

  useEffect(() => {
    mixpanel.track('View bill creation success screen', { Origin: routerHistory[routerHistory.length - 1] });
  }, []);

  return (
    <div className={STYLES.WRAPPER}>
      <div className='w-fit mx-auto mt-[45px] mb-2'>
        <Avatar id={selectedVendor?.supplierId || ''} name={selectedVendor?.name || ''} size={AvatarSize.LARGE} />
      </div>
      <Heading title={t(`The bill from ${selectedVendor?.name} has been added`)} className={`${STYLES.TITLE} text-center`} />
      <div className={STYLES.BILL_INFO_WRAPPER}>
        <p className={STYLES.TITLE}>{t(TEXTS.BILL_DETAILS)}</p>
        <div className={STYLES.FLEX_BETWEEN + STYLES.BORDER_BOTTOM}>
          <span className={STYLES.BILL_ITEM}>{t(TEXTS.AMOUNT)}</span>
          <span className={STYLES.PRICE}>
            {convertValueToUSD(billData.amount, 2)}
          </span>
        </div>
        <div className={`${STYLES.FLEX_BETWEEN} mt-4`}>
          <span className={STYLES.BILL_ITEM}>{t(TEXTS.DUE_DATE)}</span>
          <span className={STYLES.BILL_VALUE}>{format(billData?.dueDate || new Date(), 'MMM dd, yyyy')}</span>
        </div>
        {billData.billNumber && (
          <div className={`${STYLES.FLEX_BETWEEN} mt-[10px]`}>
            <span className={STYLES.BILL_ITEM}>{t(TEXTS.BILL_NUMBER)}</span>
            <span className={STYLES.BILL_VALUE}>{`#${billData.billNumber}`}</span>
          </div>
        )}

      </div>
      {billData.assetName && (
        <div className={STYLES.FILE_PREVIEW}>
          <AttachmentAdded className='w-[24px] mr-[10px]' />
          <span className={STYLES.BILL_VALUE}>{billData.assetName}</span>
        </div>
      )}
      <div className={STYLES.ACTIONS_WRAPPER}>
        <Button onClick={handleProceedToPayment} className={STYLES.BUTTON_PROCEED} id='ProceedToPayment' title={t(BUTTONS_TITLES.PROCEED_TO_PAYMENT)} />
        <Button onClick={handleMakeAnotherBill} className={STYLES.BUTTON_MAKE_BILL} id='MakeAnotherBill' title={t(BUTTONS_TITLES.MAKE_BILL)} />
        <Button onClick={handleDone} className={STYLES.DONE} id='Done' title={t(BUTTONS_TITLES.DONE)} />
      </div>
    </div>
  );
};
